// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"page_sectionContainer__ke5U3","container":"page_container__dDsGk","bodyContainer":"page_bodyContainer__QvGuN"};